import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box } from "@mui/material";
import { keyframes } from "@emotion/react";

// Animation pour l'illustration
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
`;

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 600,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: theme.spacing(6, 2),
}));

const AnimatedImage = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: 300,
  animation: `${bounce} 2s infinite`,
}));

export default function ErrorPage() {
  return (
    <>
      <title>404 Page Not Found</title>

      <Container>
        <StyledContent>
          <AnimatedImage
            src="/assets/images/restaurant-plate-404.svg"
            alt="404 Error"
          />
          <Typography variant="h3" paragraph>
            Oups, page introuvable !
          </Typography>
          <Typography sx={{ color: "text.secondary", mb: 4 }}>
            {"Désolé, nous n'avons pas pu trouver la page que vous recherchez. Peut-être qu'elle est en train de mijoter ?"}
          </Typography>
          <Button
            to="/"
            size="large"
            variant="contained"
            component={RouterLink}
            sx={{
              bgcolor: "#161C21",
              "&:hover": { bgcolor: "#161C21" },
            }}
          >
            {"Retour à l'accueil"}
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
